import { Provider } from "urql";
import { ReactNode } from "react";
import { contentfulClient } from "../../utils/contentfulClient";

export const ContentfulClientProvider = ({
  children,
}: {
  children: ReactNode;
}) => <Provider value={contentfulClient}>{children}</Provider>;
